import axios from "axios";
export { default as html } from "./DOM";
// export const readExcel = (f) => {
// 	//f = file
// 	const name = f.name;
// 	const reader = new FileReader();
// 	reader.onload = (evt) => {
// 		// evt = on_file_select event
// 		/* Parse data */
// 		const bstr = evt.target.result;
// 		const wb = XLSX.read(bstr, { type: 'binary' });
// 		/* Get first worksheet */
// 		const wsname = wb.SheetNames[0];
// 		const ws = wb.Sheets[wsname];
// 		/* Convert array of arrays */
// 		const data = XLSX.utils.sheet_to_csv(ws, { header: 1 });
// 		/* Update state */
// 		console.log('Data>>>' + data);
// 	};
// 	reader.readAsBinaryString(f);
// };

import Debugger from "@debugger";
const logger = new Debugger("helpers");

export const downloadExcel = (blob, options = {}) => {
    try {
        if (!blob) {
            throw new Error("Blob is not defined");
        }

        // Create new URL object and attached the blob
        const url = window.URL.createObjectURL(new Blob([blob]));
        // Create <a> tag
        const link = document.createElement("a");
        let name = options.name || "excel_export";
        let today = new Date(),
            date = `${today.getFullYear()}${(
                "0" +
                (today.getMonth() + 1)
            ).slice(-2)}${("0" + today.getDate()).slice(-2)}`;

        // REMOVED  + "_" + Date.now(); PER BRIT
        name += " - " + date;
        // Generate a title
        // const title = "SEARCH_RESULTS_" + Date.now();
        let title = name;

        if (options.hasOwnProperty("date") && !options.date) {
            title = options.name;
        }

        link.href = url;

        let type = options.type || ".xlsx";

        link.setAttribute("download", title + type); // or any other extension
        logger.log("downloadExcel", link);
        document.body.appendChild(link);
        link.click();
    } catch (error) {
        logger.log("downloadExcel", { error });
    }
};

export const downloadFile = (blob, options = {}) => {
    try {
        if (!blob) {
            throw new Error("Blob is not defined");
        }

        // Create new URL object and attached the blob
        const url = window.URL.createObjectURL(new Blob([blob]));
        // Create <a> tag
        const link = document.createElement("a");
        let name = options.name || "report";
        let today = new Date(),
            date = `${today.getFullYear()}${(
                "0" +
                (today.getMonth() + 1)
            ).slice(-2)}${("0" + today.getDate()).slice(-2)}`;

        // REMOVED  + "_" + Date.now(); PER BRIT
        name += " - " + date;
        // Generate a title
        // const title = "SEARCH_RESULTS_" + Date.now();
        let title = name;

        if (options.hasOwnProperty("date") && !options.date) {
            title = options.name;
        }

        link.href = url;

        let type = options.type || ".pdf";

        link.setAttribute("download", `${title}.${type}`); // or any other extension

        logger.log("downloadFile", link);
        document.body.appendChild(link);
        link.click();
    } catch (error) {
        logger.log("downloadFile", { error });
    }
};

export const setCSRF = () => {
    let token = document.head.querySelector('meta[name="csrf-token"]');

    if (token.content) {
        axios.defaults.headers.common["X-CSRF-TOKEN"] = token.content;
    } else {
        console.error(
            "CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token",
        );
    }
    return token.content;
};

export const getApiToken = () => {
    let token = document.head.querySelector('meta[name="api-token"]');
    if (!token) {
        return false;
    }
    return token.content;
};

export const isMobileDevice = () => {
    return (
        typeof window.orientation !== "undefined" ||
        navigator.userAgent.indexOf("IEMobile") !== -1
    );
};

export const paginateList = (array, page_size, page_number) => {
    --page_number; // because pages logically start with 1, but technically with 0
    return array.slice(page_number * page_size, (page_number + 1) * page_size);
};

export const currencyFormat = (number) => {
    let newNumber = parseFloat(number);
    if (isNaN(newNumber)) {
         
        consoleDebug(
            "currencyFormat: Invalid number - received: " + typeof number,
        );
        return number;
    }

    const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
        currencySign: "accounting",
    });

    return formatter.format(newNumber);
};

export const percentageFormat = (number) => {
    let newNumber = parseFloat(number);
    if (isNaN(newNumber)) {
         
        consoleDebug(
            "percentageFormat: Invalid number - received: " + typeof number,
        );
        return number;
    }

    const formatter = new Intl.NumberFormat("en-US", {
        style: "unit",
        unit: "percent",
        // signDisplay: "exceptZero",
        maximumFractionDigits: 2,
    });

    return formatter.format(newNumber);
};

export const decimalFormat = (number) => {
    const formatter = new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
    return formatter.format(number);
};

export const isEmptyObj = (obj) => {
     
    for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
            return false;
        }
    }
    return true;
};

export const toBinary = (tring) => {
    let binary = "";
    for (let i = 0; i < tring.length; i++) {
        binary += tring[i].charCodeAt(0).toString(2) + " ";
    }
    return binary;
};

export const getToday = () => {
    const currentDate = new Date();

    const date = currentDate.getDate();
    const month = currentDate.getMonth() + 1; //    DESC: Be careful! January is 0 not 1
    const year = currentDate.getFullYear();

    const d = date < 10 ? `0${date}` : date;
    const m = month < 10 ? `0${month}` : month;

    return year + "-" + m + "-" + d;
};
export const getDateString = (currentDate) => {
    const date = currentDate.getDate();
    const month = currentDate.getMonth() + 1; //    DESC: Be careful! January is 0 not 1
    const year = currentDate.getFullYear();

    const d = date < 10 ? `0${date}` : date;
    const m = month < 10 ? `0${month}` : month;

    return year + "-" + m + "-" + d;
};

export const getCurrentTime = () => {
    const today = new Date();
    return (
        today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds()
    );
};

export const getDateTime = () => {
    const today = new Date();

    const date = today.getDate();
    const month = today.getMonth() + 1; //    DESC: Be careful! January is 0 not 1
    const year = today.getFullYear();

    const d = date < 10 ? `0${date}` : date;
    const m = month < 10 ? `0${month}` : month;

    const hour = today.getHours();
    const minute = today.getMinutes();
    const second = today.getSeconds();

    const ho = hour < 10 ? `0${hour}` : hour;
    const mi = minute < 10 ? `0${minute}` : minute;
    const se = second < 10 ? `0${second}` : second;

    const currentDate = year + "-" + m + "-" + d;
    const currentTime = ho + ":" + mi + ":" + se;
    return currentDate + "T" + currentTime;
};

export const dateTimePrettier = (datetime) => {
    // sometimes even the US needs 24-hour time
    const options = {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        hour12: false,
        timeZone: "America/Los_Angeles",
    };
    // → "12/19/2012, 19:00:00"
    return new Intl.DateTimeFormat("en-US", options).format(new Date(datetime));
};

export const toISOString = (date) => {
    function pad(number) {
        if (number < 10) {
            return "0" + number;
        }
        return number;
    }
    return (
        date.getFullYear() +
        "-" +
        pad(date.getMonth() + 1) +
        "-" +
        pad(date.getDate()) +
        "T" +
        pad(date.getHours()) +
        ":" +
        pad(date.getMinutes()) +
        ":" +
        pad(date.getSeconds()) +
        "." +
        (date.getMilliseconds() / 1000).toFixed(3).slice(2, 5) +
        "Z"
    );
};

export const isDateTime = (datetime) => {
    const pattern = new RegExp(
        /[0-9]{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])(T)?(2[0-3]|[01][0-9]):[0-5][0-9]:?[0-9]?[0-9]?/,
    );
    return pattern.test(datetime);
};

export const truncateString = (str, num) => {
    // If the length of str is less than or equal to num
    // just return str--don't truncate it.
    if (str.length <= num) {
        return str;
    }
    // Return str truncated with '...' concatenated to the end of str.
    return str.slice(0, num) + "...";
};

export const sortObjectAlphabetically = (object) => {
    return Object.keys(object).sort(function (a, b) {
        return object[a] - object[b];
    });
};
export const setSocketID = (token) => {
    window.axios.defaults.headers.common["X-Socket-ID"] = token;
};

export const isJsonOrString = (str) => {
    let json;
    try {
        json = JSON.parse(str);
    } catch (e) {
        return str;
    }
    return json;
};

export const isJson = (str) => {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
};

export const isFunction = (functionToCheck) => {
    return (
        functionToCheck &&
        {}.toString.call(functionToCheck) === "[object Function]"
    );
};

// Returns a string or an array
export const toArray = (item) => {
    if (Array.isArray(item)) {
        return item;
    }
    try {
        return JSON.parse(item);
    } catch (error) {
         
        consoleLog({
            error,
            msg:
                "typeof item passes into toArray is not a String or Array. Received: " +
                typeof item,
        });
        return false;
    }
};

// Returns only an array
export const convertToArray = (item) => {
    if (Array.isArray(item)) {
        return item;
    }
    try {
        return [...JSON.parse(item)];
    } catch (error) {
         
        consoleLog({
            error,
            msg:
                "typeof item passes into convertToArray is not a String or Array. Received: " +
                typeof item +
                ", Value: " +
                item,
        });
        return false;
    }
};

export const daysBetween = (startDate, endDate) => {
    const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
    console.log(startDate, endDate);
    return Math.round((startDate - endDate) / oneDay);
};

export function daysDiff(date1, date2, interval) {
    let second = 1000,
        minute = second * 60,
        hour = minute * 60,
        day = hour * 24,
        week = day * 7;
    date1 = new Date(date1);
    date2 = new Date(date2);
    let timediff = date2 - date1;
    if (isNaN(timediff)) {
        return NaN;
    }
    switch (interval) {
        case "years":
            return date2.getFullYear() - date1.getFullYear();
        case "months":
            return (
                date2.getFullYear() * 12 +
                date2.getMonth() -
                (date1.getFullYear() * 12 + date1.getMonth())
            );
        case "weeks":
            return Math.floor(timediff / week);
        case "days":
            return Math.floor(timediff / day);
        case "hours":
            return Math.floor(timediff / hour);
        case "minutes":
            return Math.floor(timediff / minute);
        case "seconds":
            return Math.floor(timediff / second);
        default:
            return undefined;
    }
}

export const toNumberFloat = (number) => {
    let newNumber = parseFloat(number);
    if (isNaN(newNumber)) {
         
        consoleDebug(
            "toNumberFloat: invalid number - received: " + typeof number,
        );
        return number;
    }
    return newNumber;
};

export const deepObjectCopy = (obj) => {
    try {
        return JSON.parse(JSON.stringify(obj));
    } catch (error) {
         
        consoleDebug({
            error,
            msg:
                "typeof item passes into deepObjectCopy is not an Object. Received: " +
                typeof obj,
        });
        return false;
    }
};

export const arrayLengthMatch = (arr1, arr2) => {
    try {
        if (Array.isArray(arr1) && Array.isArray(arr2)) {
            return arr1.length === arr2.length;
        }
        return new Error("arguments are not array");
    } catch (error) {
         
        consoleLog({
            error,
            msg:
                "typeof item passes into deepObjectCopy is not an Object. Received: " +
                typeof arr1 +
                " - " +
                typeof arr2,
        });
        return false;
    }
};
export const arrayMatchAsString = (arr1, arr2) => {
    try {
        if (Array.isArray(arr1) && Array.isArray(arr2)) {
            return arr1.toString() === arr2.toString();
        }
        return new Error("arguments are not array");
    } catch (error) {
         
        consoleLog({
            error,
            msg:
                "typeof item passes into deepObjectCopy is not an Object. Received: " +
                typeof arr1 +
                " - " +
                typeof arr2,
        });
        return false;
    }
};

export const copyToClipboard = (text) => {
    let input = document.createElement("input");

    input.type = "text";
    input.value = text;
    document.querySelector("body").appendChild(input);
    input.select();
    try {
        document.execCommand("copy");
    } catch (e) {
        console.log(e);
    }
    input.remove();
};
export const sleep = async (ms) => {
     
    return new Promise((resolve) => setTimeout(resolve, ms));
};
export const getBaseUrl = () => window.location.origin;

export const onEnterSpacePress = (event) => {
    return [32, 13].includes(event.keyCode);
};

export function deepEqual(object1, object2) {
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) {
        return false;
    }
    for (const key of keys1) {
        const val1 = object1[key];
        const val2 = object2[key];
        const areObjects = isObject(val1) && isObject(val2);
        if (
            (areObjects && !deepEqual(val1, val2)) ||
            (!areObjects && val1 !== val2)
        ) {
            return false;
        }
    }
    return true;
}

export function isObject(object) {
    return object != null && typeof object === "object";
}

export const isValidDate = (date) => {
    // check the date is the outcome of a completed date input
    return date instanceof Date && !isNaN(date);
};

export const isValidDateInput = (date) => {
    // matches with the YYYY-MM-DD format
    return /^\d{4}-\d{2}-\d{2}$/.test(date);
};

